import styled from '@emotion/styled';

const Container = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
});

export default Container;
